import { createImpersonationStore } from './store';
import { persistStickyImpersonateEmail, readImpersonateFromUrl, readStickyImpersonateEmail, writeImpersonateToBrowserUrl, } from './urlSync';
let singleton = null;
/**
 * Wires the impersonation store to the auth module:
 *  - When the authenticated user is a support superuser, the store is seeded from the URL
 *    (falling back to localStorage), and the URL + localStorage are synced on every change.
 *  - For all other auth states, impersonation is cleared.
 *
 * Idempotent. Returns the existing module if already installed.
 */
export function installImpersonation(auth) {
    if (singleton)
        return singleton;
    const store = createImpersonationStore();
    const applyForUser = (isSuperuser) => {
        if (!isSuperuser) {
            if (store.getEmail()) {
                persistStickyImpersonateEmail('');
                writeImpersonateToBrowserUrl('');
                store.setEmail('');
            }
            return;
        }
        const fromUrl = readImpersonateFromUrl();
        const fromStorage = readStickyImpersonateEmail();
        const resolved = fromUrl || fromStorage;
        if (resolved) {
            persistStickyImpersonateEmail(resolved);
            writeImpersonateToBrowserUrl(resolved);
            store.setEmail(resolved);
        }
    };
    const onAuthChange = () => {
        const status = auth.getStatus();
        if (status.kind === 'authenticated') {
            applyForUser(status.user.isSupportSuperuser);
        }
        else {
            if (store.getEmail()) {
                persistStickyImpersonateEmail('');
                writeImpersonateToBrowserUrl('');
                store.setEmail('');
            }
        }
    };
    onAuthChange();
    const unsubscribe = auth.subscribe(onAuthChange);
    const module = {
        getEmail: () => store.getEmail(),
        subscribe: (listener) => store.subscribe(listener),
        setEmail(next) {
            persistStickyImpersonateEmail(next);
            writeImpersonateToBrowserUrl(next);
            store.setEmail(next);
        },
        dispose() {
            unsubscribe();
            if (singleton === module)
                singleton = null;
        },
    };
    singleton = module;
    return module;
}
export function getImpersonationModule() {
    if (!singleton) {
        throw new Error('Impersonation module not installed. Call installImpersonation(auth) once at bootstrap.');
    }
    return singleton;
}
